import Vue from 'vue'
import Pagination from '@/components/Pagination'
import basicBlock from '@/components/basic-block/main'
import basicContainer from '@/components/basic-container/main'
import YdTable from '@/components/com-public/com-yd-table'
import YdDriverCarSelector from '@/components/com-business/com-driver-car-selector'
import YdMerchantSelector from '@/components/com-business/com-merchant-selector'
import YdRoleSelector from '@/components/com-business/com-role-selector'
import YdIDCardTypeSelector from '@/components/com-business/com-id-card-type-selector'
import YdOrderResourceSelector from '@/components/com-business/com-order-resource-selector'
import YdCommonSelector from '@/components/com-business/com-common-selector'
import YdLineSelector from '@/components/com-business/com-line-selector'
import YdAdminUserSelect from '@/components/com-business/com-admin-user-selector'
import YdBusinessTypeSelector from '@/components/com-business/com-yd-business-type-selector'
import YdCityLevelSelector from '@/components/com-business/com-city-level-selector'
import YdStationSelector from '@/components/com-business/com-station-selector'
import YdPostSelect from '@/components/com-business/com-post-selector'
import YdPassengerSelect from '@/components/com-business/com-passenger-selector'
import YdDialog from '@/components/com-public/com-yd-dialog'
import YdCarSeatTypeSelect from '@/components/com-business/com-car-seat-type-selector'
import YdLineTimeSelect from '@/components/com-business/com-line-time-selector'
import YdLink from '@/components/com-business/com-link'
import YdMapLocation from '@/components/com-business/com-map-location'
// 固钉
import YdAffix from '@/components/com-public/com-yd-affix'
import YdServiceAreaSelect from '@/components/com-business/com-service-area-selector'
import YdDeptSelect from '@/components/com-business/com-dept-selector'
import YdCitySelect from '@/components/com-business/com-city-selector'
import YdResponsibilitySelect from '@/components/com-business/com-responsibility-selector'
import YdRefundReasonSelect from '@/components/com-business/com-refundReason-selector'
import YdEmployeeSelect from '@/components/com-business/com-employee-selector'
import YdLabelSelect from '@/components/com-business/com-label-selector'
import YdLine from '@/components/com-ui/yd-line'
import YdScrollBar from '@/components/com-ui/yd-scroll-bar'
import YdCode from '@/components/com-business/com-code'
import YdChannelSelect from '@/components/ChannelSelect'
import searchForm from '../components/SearchForm/index.vue'
import commonDialog from '../components/commonDialog/index.vue'
import FerryDriverSelect from '../components/FerryDriverSelect/index.vue'
// 注册全局容器
Vue.component('basicContainer', basicContainer)
Vue.component('basicBlock', basicBlock)
Vue.component('Pagination', Pagination)
Vue.component('YdTable', YdTable)
Vue.component('YdDriverCarSelector', YdDriverCarSelector)
Vue.component('YdMerchantSelector', YdMerchantSelector)
Vue.component('YdRoleSelector', YdRoleSelector)
Vue.component('YdIDCardTypeSelector', YdIDCardTypeSelector)
Vue.component('YdOrderResourceSelector', YdOrderResourceSelector)
Vue.component('YdCommonSelector', YdCommonSelector)
Vue.component('YdLineSelector', YdLineSelector)
Vue.component('YdAdminUserSelect', YdAdminUserSelect)
Vue.component('YdBusinessTypeSelector', YdBusinessTypeSelector)
Vue.component('YdCityLevelSelector', YdCityLevelSelector)
Vue.component('YdStationSelector', YdStationSelector)
Vue.component('YdPostSelect', YdPostSelect)
Vue.component('YdPassengerSelect', YdPassengerSelect)
Vue.component('YdDialog', YdDialog)
Vue.component('YdCarSeatTypeSelect', YdCarSeatTypeSelect)
Vue.component('YdLineTimeSelect', YdLineTimeSelect)
Vue.component('YdAffix', YdAffix)
Vue.component('YdServiceAreaSelect', YdServiceAreaSelect)
Vue.component('YdDeptSelect', YdDeptSelect)
Vue.component('YdCitySelect', YdCitySelect)
Vue.component('YdResponsibilitySelect', YdResponsibilitySelect)
Vue.component('YdRefundReasonSelect', YdRefundReasonSelect)
Vue.component('YdEmployeeSelect', YdEmployeeSelect)
Vue.component('YdLabelSelect', YdLabelSelect)
Vue.component('YdLine', YdLine)
Vue.component('YdScrollBar', YdScrollBar)
Vue.component('YdCode', YdCode)
Vue.component('YdLink', YdLink)
Vue.component('YdMapLocation', YdMapLocation)
Vue.component('YdChannelSelect', YdChannelSelect)
Vue.component('YDSearchForm', searchForm)
Vue.component('YDCommonDialog', commonDialog)
Vue.component('FerryDriverSelect', FerryDriverSelect)
